<script lang="ts" setup>
  import { computed, onMounted, ref, toRefs } from 'vue'

  import type { EmployeeNotificationJsonldDefaultRead, NotificationEstimationRequestJsonldDefaultRead, TaskJsonldDefaultRead } from '@/api'
  import { useGeneratedTaskStore } from '@/stores'
  import Menu from 'primevue/menu'
  import type { MenuItem } from 'primevue/menuitem'
  import SpinnerDefault from '@/elements/SpinnerDefault.vue'
  import AnchorRouter from '@/elements/AnchorRouter.vue'
  import { useRouter } from 'vue-router'
  import ButtonDefault from '@/elements/ButtonDefault.vue'

  interface Props {
    notification: EmployeeNotificationJsonldDefaultRead
  }

  const props = defineProps<Props>()
  const { notification } = toRefs(props)

  const r = useRouter()
  const data = computed(() => notification.value.data as NotificationEstimationRequestJsonldDefaultRead)
  const loading = ref(true)
  const menu = ref<InstanceType<typeof Menu>>()
  const menuItems = ref<MenuItem[]>([
    {
      label: 'Schätzung öffnen',
      command: () => {
        debugger
        void r.push({ name: 'task_details', params: { id: data.value.task } })
      }
    }
  ])

  function toggleMenu(e: Event) {
    menu.value?.toggle(e)
  }

  const task = ref<TaskJsonldDefaultRead>()
  onMounted(async () => {
    if (data.value.task)
      task.value = await useGeneratedTaskStore()
        .fetchById(data.value.task)
        .then((d) => d.value)
    loading.value = false
  })

  const emit = defineEmits<{ read: [Event]; close: [Event] }>()

  function onAnchorClicked(e: Event) {
    emit('close', e)
    emit('read', e)
  }
</script>

<template>
  <div class="flex flex-row">
    <div class="flex-1">
      <span class="text-sm font-semibold leading-6">Neue Aufwandsschätzung angefordert:</span>
      <br />
      <template v-if="!task">
        <SpinnerDefault class="size-4 self-center" />
      </template>
      <template v-else>
        <AnchorRouter
          :to="{ name: 'task_details', params: { id: task.id } }"
          underline="dashed"
          @click="onAnchorClicked">
          {{ task?.title }}
        </AnchorRouter>
      </template>
    </div>
    <div class="flex-0 items-center gap-x-4">
      <ButtonDefault
        label="..."
        outlined
        plain
        size="small"
        @click="toggleMenu" />
      <Menu
        ref="menu"
        :model="menuItems"
        class="relative flex-none"
        popup />
    </div>
  </div>
</template>
